import { render } from "./RFIDCharts.vue?vue&type=template&id=794ee09c&scoped=true"
import script from "./RFIDCharts.vue?vue&type=script&lang=js"
export * from "./RFIDCharts.vue?vue&type=script&lang=js"

import "./RFIDCharts.vue?vue&type=style&index=0&id=794ee09c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794ee09c"]])

export default __exports__